module.exports = __webpack_public_path__ + "static/media/notif_msg_cupon.959add8b.png";